<template>
  <footer class="premium-footer">
    <div class="premium-footer__inner">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-brand__mark">
            <img
              src="@/assets/ministryOfHealthLogo.png"
              alt="FMOH Logo"
              class="footer-brand__logo"
            />
          </div>

          <div class="footer-brand__copy">
            <span class="footer-kicker">Federal Ministry of Health</span>
            <h2>Health Partners' Projects & Data Mapping Platform</h2>
            <p>
              Department of Health Planning, Research and Statistics, Federal Ministry of Health,
              3rd floor, New Federal Secretariat Complex, Phase II, Central Business District (FCT),
              Abuja Nigeria.
            </p>
            <b-link to="/ngo/contact-us" class="footer-contact">
              <i class="fas fa-envelope-open-text"></i>
              <span>Contact Us</span>
            </b-link>
          </div>
        </div>

        <div class="footer-grid">
          <section class="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li><b-link to="/">Home</b-link></li>
              <li><b-link to="/inventory/project">Project Inventory</b-link></li>
              <li><b-link to="/inventory/dataset">Data Inventory</b-link></li>
            </ul>
          </section>

          <section class="footer-column">
            <h3>Inventory Partners</h3>
            <ul>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://ehealth4everyone.com/">
                  eHealth4everyone
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.gatesfoundation.org/"
                >
                  Bill and Melinda Gates Foundation
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.health.gov.ng/index.php/department/information-communication-technology"
                >
                  FMOH-ICT Department
                </a>
              </li>
            </ul>
          </section>

          <section class="footer-column">
            <h3>Other Links</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://dhis2nigeria.org.ng/dhis/dhis-web-commons/security/login.action"
                >
                  DHIS2 Nigeria
                </a>
              </li>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.health.gov.ng/">
                  Federal Ministry Of Health
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nigerianstat.gov.ng/nada/index.php/catalog"
                >
                  National Bureau of Statistics
                </a>
              </li>
            </ul>
          </section>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2025 Federal Ministry of Health. All Rights Reserved.</p>
        <div class="social-icons">
          <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
          <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
};
</script>

<style scoped>
.premium-footer {
  padding: 2rem 1rem 1rem;
  background: radial-gradient(circle at top left, rgba(48, 171, 76, 0.12), transparent 24%),
    linear-gradient(180deg, #eef6f0 0%, #f7fbf8 100%);
  border-top: 1px solid rgba(24, 57, 31, 0.08);
}

.premium-footer__inner {
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 32px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(245, 250, 246, 0.95)), #ffffff;
  box-shadow: 0 22px 50px rgba(20, 55, 31, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.footer-top {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 2rem;
  padding-bottom: 1.5rem;
}

.footer-brand {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
}

.footer-brand__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  flex-shrink: 0;
  border-radius: 26px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(235, 243, 237, 0.96));
  border: 1px solid rgba(48, 171, 76, 0.18);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75), 0 16px 32px rgba(36, 92, 50, 0.12);
}

.footer-brand__logo {
  width: 62px;
  height: 62px;
  object-fit: contain;
}

.footer-brand__copy {
  max-width: 38rem;
}

.footer-kicker,
.footer-column h3 {
  margin: 0 0 0.5rem;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.footer-kicker {
  display: inline-block;
  color: #2b8b44;
}

.footer-brand__copy h2 {
  margin: 0 0 0.7rem;
  font-size: clamp(1.35rem, 2vw, 2rem);
  line-height: 1.12;
  color: #163322;
}

.footer-brand__copy p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #577064;
}

.footer-contact {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  margin-top: 1rem;
  padding: 0.8rem 1rem;
  border-radius: 16px;
  background: rgba(48, 171, 76, 0.08);
  color: #1f6f33;
  text-decoration: none;
  font-weight: 700;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.footer-column {
  padding: 1rem 1.05rem;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(251, 253, 251, 0.96), rgba(241, 247, 242, 0.96));
  border: 1px solid rgba(28, 68, 38, 0.08);
}

.footer-column h3 {
  color: #20412b;
}

.footer-column ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-column li + li {
  margin-top: 0.75rem;
}

.footer-column a {
  color: #4a6758;
  text-decoration: none;
  line-height: 1.55;
  transition: color 0.2s ease, transform 0.2s ease;
}

.footer-column a:hover,
.footer-contact:hover {
  color: #1f6f33;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(24, 57, 31, 0.08);
}

.footer-bottom p {
  margin: 0;
  color: #60796b;
  font-size: 0.9rem;
}

.social-icons {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
}

.social-icons a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: linear-gradient(135deg, #1f6f33, #2fa049);
  color: #ffffff;
  text-decoration: none;
  box-shadow: 0 12px 22px rgba(31, 111, 51, 0.18);
}

@media (max-width: 991px) {
  .footer-top {
    grid-template-columns: 1fr;
  }

  .footer-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .premium-footer {
    padding: 1rem 0.5rem 0.75rem;
  }

  .premium-footer__inner {
    padding: 1.2rem;
    border-radius: 24px;
  }

  .footer-brand {
    flex-direction: column;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
